var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogsBgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 869,
    viewBox: "0 0 1440 869",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_745_5248)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 437,
    height: 1862,
    rx: 218.5,
    transform: "matrix(0.642788 -0.766044 0.766083 0.642742 -181 -328)",
    fill: "url(#paint0_linear_745_5248)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4171,
    y: -1.34928,
    width: 280.114,
    height: 818.114,
    rx: 140.057,
    transform: "matrix(0.642788 -0.766044 0.766083 0.642742 -99.4592 271.328)",
    stroke: "url(#paint1_linear_745_5248)",
    strokeOpacity: 0.31,
    strokeWidth: 21.8858
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_745_5248",
    x: -124.933,
    y: -606.7,
    width: 1595.21,
    height: 1419.42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.63,
    result: "effect1_foregroundBlur_745_5248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_5248",
    x1: 268.953,
    y1: -400.913,
    x2: 223.811,
    y2: 1862.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145708,
    stopColor: "#D0FBEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373644,
    stopColor: "#C3F8E9",
    stopOpacity: 0.536558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AEDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_745_5248",
    x1: 151,
    y1: 0,
    x2: 151,
    y2: 840,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495114,
    stopColor: "#D0FBEF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsBgIc);
export default __webpack_public_path__ + "static/media/blogsBg_ic.e90630aa.svg";
export { ForwardRef as ReactComponent };